import React, { useEffect, useState } from "react";
import API from "../api";
import "../App.css";

function ProductList({ onSelectProduct }) {  
  const [products, setProducts] = useState([]);

  useEffect(() => {
    API.get("/products")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  return (
    <div className="product-container">
      <h2 className="section-title"> Available Products</h2>
      <div className="product-grid">
        {products.map((p) => (
          <div className="product-card" key={p.id}>
            <img src={p.image} alt={p.title} className="product-img" />
            <h3 className="product-title">{p.title.substring(0, 25)}...</h3>
            <p className="product-price">${p.price}</p>
            <button
              className="btn-primary"
              onClick={() => onSelectProduct(p)}  
            >
              Order Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductList;
